/**
 * 系统设置 API（业务配置参数读取与更新）。
 *
 * 对齐后端 business-config change（1-4）的 REST 契约：
 * - GET /system-settings -> SystemSettings
 * - GET /system-settings/defaults -> SystemSettings（安全默认值）
 * - PATCH /system-settings -> SystemSettings（partial 更新）
 *
 * 路径从 api.config.ts 导入，禁止内联；Transport 统一解包 `{success, data}` 信封。
 */
import { ApiPaths } from './api.config';
import { http } from './transport';

/** 报名来源项。 */
export interface EnrollmentSourceItem {
  value: string;
  label: string;
}

/** 全部业务配置结构化视图（对齐后端 SystemSettings）。 */
export interface SystemSettings {
  paymentLinkExpireMinutes: number;
  enrollmentValidDays: number;
  orderExpireHours: number;
  orderAutoCancelEnabled: boolean;
  trialExhaustionAutoExitEnabled: boolean;
  balanceReminderEnabled: boolean;
  balanceReminderAheadDays: number;
  wechatNotifyEnabled: boolean;
  wechatNotifyPaymentSuccess: boolean;
  wechatNotifyBalanceDue: boolean;
  wechatNotifyScheduleChange: boolean;
  enrollmentSources: EnrollmentSourceItem[];
}

/** 更新请求体（partial，每个字段可选）。 */
export type UpdateSystemSettings = Partial<Omit<SystemSettings, 'enrollmentSources'>> & {
  enrollmentSources?: EnrollmentSourceItem[];
};

async function getSettings(): Promise<SystemSettings> {
  return http.get<SystemSettings>(ApiPaths.systemSettings.list);
}

async function getDefaults(): Promise<SystemSettings> {
  return http.get<SystemSettings>(ApiPaths.systemSettings.defaults);
}

async function updateSettings(
  patch: UpdateSystemSettings,
): Promise<SystemSettings> {
  return http.patch<SystemSettings>(ApiPaths.systemSettings.update, patch);
}

/** 系统设置 API 唯一对外入口。 */
export const systemSettingsApi = { getSettings, getDefaults, updateSettings };
